export default {"src":"/_next/static/media/iq.9fc52ca2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};